// @flow

export function numberLessThanLimit(number: number, limit: number){
  return number < limit || !limit; // -1 will equal unlimited
}